import { useState, useEffect } from 'react';

export function useTypewriter(words, { typeSpeed = 80, deleteSpeed = 45, pause = 1800 } = {}) {
  const [display, setDisplay] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    const current = words[wordIndex];

    if (typing) {
      if (display.length < current.length) {
        const t = setTimeout(() => setDisplay(current.slice(0, display.length + 1)), typeSpeed);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => setTyping(false), pause);
        return () => clearTimeout(t);
      }
    } else {
      if (display.length > 0) {
        const t = setTimeout(() => setDisplay(display.slice(0, -1)), deleteSpeed);
        return () => clearTimeout(t);
      } else {
        setWordIndex(i => (i + 1) % words.length);
        setTyping(true);
      }
    }
  }, [display, typing, wordIndex, words, typeSpeed, deleteSpeed, pause]);

  return display;
}
